import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'

class BlogIndex extends React.Component {
  getData() {
    return get(this, 'props.data.remark.posts').filter(
      x => get(x, 'post.frontmatter.layout') === 'stih'
    )
  }

  componentWillMount() {
    this.setState({ items: this.getData() })
  }

  filterList = event => {
    const data = this.getData()
    var updatedList = JSON.parse(JSON.stringify(data))

    updatedList = updatedList.filter(function(item) {
      return (
        item.post.frontmatter.title
          .toLowerCase()
          .search(event.target.value.toLowerCase()) !== -1 ||
        item.post.html
          .toLowerCase()
          .search(event.target.value.toLowerCase()) !== -1
      )
    })
    this.setState({ items: updatedList })
  }

  /* clearText = () => {} */

  render() {
    const site = get(this, 'props.data.site.siteMetadata')

    return (
      <div className="container">
        <Helmet
          title={get(site, 'title')}
          meta={[
            /* { name: 'twitter:card', content: 'summary' }, */
            {
              property: 'vk:image',
              content: `${get(site, 'url')}/img/vkimage.jpg`,
            },
            { property: 'og:title', content: get(site, 'title') },
            { property: 'og:type', content: 'website' },
            { property: 'og:description', content: get(site, 'description') },
            { property: 'og:url', content: get(site, 'url') },
            {
              property: 'og:image',
              content: `${get(site, 'url')}/img/ogimage.jpg`,
            },
          ]}
        />
        <div className="row">
          <div className="col-12 mt-5">
            <input
              type="text"
              className="form-control form-control-lg mb-3"
              placeholder="Название или текст духовного стиха"
              onChange={this.filterList}
            />
            {/* <span className="form-control-clear glyphicon glyphicon-remove form-control-feedback hidden" onClick={this.clearText}></span> */}
          </div>
          <List items={this.state.items} />
        </div>
      </div>
    )
  }
}

const List = ({ items }) => {
  return (
    <ul className="col-12 mt-1">
      {items.map(function(item, index) {
        const path = get(item, 'post.frontmatter.path')
        const title = get(item, 'post.frontmatter.title')
        return (
          <Link to={path} key={index}>
            <li className="list-group-item h5" key={index}>
              {title}
            </li>
          </Link>
        )
      })}
    </ul>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        description
        url: siteUrl
        author
        twitter
        adsense
      }
    }
    remark: allMarkdownRemark {
      posts: edges {
        post: node {
          html
          frontmatter {
            layout
            title
            path
            categories
            date(formatString: "YYYY/MM/DD")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js